import { GESTURES } from "../avatar/catalog";
import { requireElement } from "./Hud";

/**
 * Seletor de gestos: o botao do HUD (no toque, o botao da coluna de acoes
 * faz o mesmo) abre uma grade com os gestos do catalogo. Escolher um gesto o
 * deixa em loop ate o jogador andar; escolher o mesmo de novo para.
 */
export class GestureMenu {
  private readonly button = requireElement<HTMLButtonElement>("gesture-btn");
  private readonly menu = requireElement<HTMLDivElement>("gesture-menu");
  private readonly items = new Map<string, HTMLButtonElement>();
  private handler?: (id: string) => void;
  private available = true;
  /** A cena diz se da para abrir agora (nao da com um overlay aberto). */
  canOpen: () => boolean = () => true;

  constructor() {
    GESTURES.forEach((g, i) => {
      const item = document.createElement("button");
      item.type = "button";
      item.className = "gesture-item";
      item.setAttribute("role", "menuitem");
      item.setAttribute("aria-pressed", "false");
      item.title = i < 9 ? `${g.label} (${i + 1})` : g.label;

      const key = document.createElement("span");
      key.className = "gesture-key";
      key.textContent = i < 9 ? String(i + 1) : "";
      const icon = document.createElement("span");
      icon.className = "gesture-icon";
      icon.textContent = g.icon;
      const label = document.createElement("span");
      label.className = "gesture-label";
      label.textContent = g.label;

      item.append(key, icon, label);
      item.addEventListener("click", () => {
        this.close();
        this.handler?.(g.id);
      });
      this.items.set(g.id, item);
      this.menu.append(item);
    });

    this.button.addEventListener("click", () => this.toggle());

    // Tocar fora fecha. Os botoes que abrem o menu ficam de fora, senao o
    // pointerdown fecharia e o click logo depois abriria de novo.
    document.addEventListener(
      "pointerdown",
      (event) => {
        const target = event.target as Element | null;
        if (!this.isOpen || !target) return;
        if (this.menu.contains(target) || target.closest("[data-gesture-toggle]")) return;
        this.close();
      },
      true,
    );
  }

  onSelect(handler: (id: string) => void): void {
    this.handler = handler;
  }

  get isOpen(): boolean {
    return !this.menu.classList.contains("hidden");
  }

  toggle(): void {
    if (this.isOpen) this.close();
    else this.open();
  }

  open(): void {
    if (!this.available || !this.canOpen()) return;
    this.menu.classList.remove("hidden");
    this.button.setAttribute("aria-expanded", "true");
  }

  close(): void {
    this.menu.classList.add("hidden");
    this.button.setAttribute("aria-expanded", "false");
  }

  /** Id do gesto pelo atalho 1..9 (indice na ordem do menu). */
  idForKey(n: number): string | undefined {
    return GESTURES[n - 1]?.id;
  }

  /** Destaca o gesto em andamento (undefined = nenhum). */
  setActive(id: string | undefined): void {
    for (const [gid, item] of this.items) {
      const on = gid === id;
      item.classList.toggle("active", on);
      item.setAttribute("aria-pressed", String(on));
    }
    this.button.classList.toggle("active", !!id);
  }

  /** Fantasmas nao fazem gestos: o botao some. */
  setAvailable(available: boolean): void {
    this.available = available;
    this.button.classList.toggle("hidden", !available);
    if (!available) this.close();
  }
}
